<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("hanwha_dvr.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="dvrFilter"
          :options="dvrOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:dvrFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("tenants.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tenantFilter"
          :options="tenantOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:tenantFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("centers.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="centerFilter"
          :options="centerOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:centerFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("sectors.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectorOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2 text-capitalize">
        <label class="text-capitalize">{{ $t("camera.online") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="onlineFilter"
          class="w-100"
          :reduce="(val) => val.value"
          :options="[
            { label: 'online', value: true },
            { label: 'offline', value: false },
          ]"
          @input="(val) => $emit('update:onlineFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("camera_proxy.rtsp_available") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="rtspAvailableFilter"
          class="w-100"
          :reduce="(val) => val.value"
          :options="[
            { label: 'enabled', value: true },
            { label: 'disabled', value: false },
          ]"
          @input="(val) => $emit('update:rtspAvailableFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("unit.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("device_tag.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="deviceTagFilter"
          :options="deviceTagOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:deviceTagFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("hanwha_camera.fisheye") }}</label>
        <b-form-checkbox
          :checked="isFisheyeFilter"
          @change="(val) => $emit('update:isFisheyeFilter', val)"
          :value="true"
          :unchecked-value="null"
          class="mt-50 text-capitalize"
          switch
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("camera_proxy.send_to_seproban") }}</label>
        <b-form-checkbox
          :checked="sendToSeprobanFilter"
          @change="(val) => $emit('update:sendToSeprobanFilter', val)"
          :value="true"
          :unchecked-value="null"
          class="mt-50 text-capitalize"
          switch
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    vSelect,
  },
  props: {
    dvrOptions: {
      type: Array,
      default: null,
    },
    dvrFilter: {
      type: Array,
      default: null,
    },
    buttonUpdate: {
      type: Boolean,
      default: false,
    },
    centerOptions: {
      type: Array,
      default: null,
    },
    centerFilter: {
      type: Array,
      default: null,
    },
    sectorOptions: {
      type: Array,
      default: null,
    },
    sectorFilter: {
      type: Array,
      default: null,
    },
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    onlineFilter: {
      type: Boolean,
      default: false,
    },
    rtspAvailableFilter: {
      type: Boolean,
      default: false,
    },
    unitOptions: {
      type: Array,
      default: null,
    },
    unitFilter: {
      type: Array,
      default: null,
    },
    deviceTagOptions: {
      type: Array,
      default: null,
    },
    deviceTagFilter: {
      type: Array,
      default: null,
    },
    isFisheyeFilter: {
      type: Boolean,
      default: null,
    },
    sendToSeprobanFilter: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
